export default (state, company) => {
    state.company = company;
}


// WEBPACK FOOTER //
// ./src/app/store/users/mutations/set-company.js